
import React from 'react';
import { Link } from 'react-router-dom';

const Contact = () => {


    return (
        <>
            <div className="banner-header section-padding valign bg-img bg-fixed bg-position-bottom" data-overlay-dark="5" style={{ backgroundImage: `url(img/slider/contactUs.jpg)` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 caption text-center">
                            <h4>Get in touch</h4>
                            <h1>Contact Us</h1>
                        </div>
                    </div>
                </div>
                <Link to="#" data-scroll-nav="1" className="mouse smoothscroll" aria-label="Scroll to section"> <span className="mouse-icon">
                    <span className="mouse-wheel"></span> </span>
                </Link>
            </div>



            <section className="rooms2 section-padding" data-scroll-index="1">
                <div className="container">
                    <div className="row">                     

                        <div className="col-lg-4 col-md-6 mb-30">
                            <figure> <img src="img/rooms/Vaishali.jpg" alt="" className="img-fluid" /> </figure>
                            <div className="content">
                                <div className="cont">
                                    <h3>The Vaishali Residency</h3>
                                    <p>Stupa Road, Dist. - Vaishali - 844128, Bihar (India)<br />
                                        <strong>Mob. No.</strong> <a href='tel:+91 92893 00356'>- +91 92893 00356</a>		<br />
                                        <strong>Tel No.</strong> -<a href='tel:+91 6112 - 255404'> +91 6112 - 255404, 255405</a><br />
                                        <strong>Email </strong>-<a href='mailto:thevaishaliresidency@gmail.com'> thevaishaliresidency@gmail.com,</a> <br />
                                        <span className="spacer2"><a href='mailto:bookings@residencygrouphotels.com'>bookings@residencygrouphotels.com</a></span></p>
                                </div>
                            </div>
                        </div>


                        <div className="col-lg-4 col-md-6 mb-30">
                            <figure> <img src="img/rooms/Bodhgaya.jpg" alt="" className="img-fluid" /> </figure>
                            <div className="content">
                                <div className="cont">
                                    <h3>The Residency</h3>
                                    <p>Near China Temple, Bodhgaya, <br />Dist. - Gaya - 824231, Bihar (India)
                                        <br /><strong>Mob. No.</strong> -<a href='tel:+91 92893 00357'> +91 92893 00357</a><br />
                                        <strong>Tel No. </strong>- <a href='tel:+0631 - 2201135'>+0631 - 2201135</a><br />
                                        <strong>Email </strong>- <a href='mailto:theresidencybodhgaya@gmail.com'>theresidencybodhgaya@gmail.com,</a> <br />
                                        <span className="spacer2"><a href='mailto:bookings@residencygrouphotels.com'>bookings@residencygrouphotels.com</a></span></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-30">
                            <figure> <img src="img/rooms/Rajgir.jpg" alt="" className="img-fluid" /> </figure>
                            <div className="content">
                                <div className="cont">
                                    <h3>The Rajgir Residency</h3>
                                    <p>Rajgir, Dist - Nalanda - 803116, Bihar (India)<br />
                                        <strong>Mob. No.</strong> -<a href='tel:+91 92893 00354'> +91 92893 00354</a><br />
                                        <strong>Tel No.</strong> - <a href='tel:+91 6112 - 255404'>+91 6112 - 255404, 255405</a><br />
                                        <strong>Email</strong> - <a href='mailto:therajgirresidency@gmail.com'>therajgirresidency@gmail.com,</a> <br />
                                        <span className="spacer2"><a href='mailto:bookings@residencygrouphotels.com'>bookings@residencygrouphotels.com</a></span></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-30">
                            <figure> <img src="img/rooms/Sravasti.jpg" alt="" className="img-fluid" /> </figure>
                            <div className="content">
                                <div className="cont">
                                    <h3>The Sravasti Residency</h3>
                                    <p>Sravasti, Dist. - Sravasti - 271805, U.P. (India)<br />
                                        <strong>Mob. No.</strong> - <a href='tel:+91 9289300358'>+91 9289300358</a><br />
                                        <strong>Tel No.</strong> - <a href='tel:+91 6112 - 255404'>+91 6112 - 255404, 255405</a><br />
                                        <strong>  Email </strong>- <a href='mailto:thesravastiresidency@gmail.com'>thesravastiresidency@gmail.com</a><br />
                                        <span className="spacer2"><a href='mailto:bookings@residencygrouphotels.com'>bookings@residencygrouphotels.com</a></span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-30">
                            <figure> <img src="img/rooms/central-hotel.jpg" alt="" className="img-fluid" /> </figure>
                            <div className="content">
                                <div className="cont">
                                    <h3>Siddhartha International</h3>
                                    <p>802, 8th Floor, New Delhi House, 27, <br />
                                        Barakhamba Road, New Delhi - 110001<br />
                                        <strong>Mob. No.</strong> - <a href='tel:+91 92893 00353'>+91 92893 00353</a><br />
                                        <strong>Tel No.</strong> - <a href='tel:+91 11-43074778'>+91 11-43074778, 23730927</a><br />
                                        <strong>Email</strong> - <a href='mailto:bookings@residencygrouphotels.com'>bookings@residencygrouphotels.com</a><br /><span className="spacer2"> info@siddharthainternational.com, siddharthai@hotmail.com</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
 

        </>
    )
};

export default Contact;
